import React from 'react';
import styled from 'styled-components';
import PT from 'prop-types';
import { Box, Typography } from '@procore/core-react';
import ProcoreLogo from '../ProcoreLogo';
import MobileLogo from '../ProcoreLogo/MobileLogo';
import { UnstyledLink } from '../../styles';

const StyledLogo = styled(Box)`
  width: 100%;
`;

const BrandingHeader = ({ isDesktop, title, marketplaceBasePath }) => {
  return (
    <UnstyledLink href={marketplaceBasePath}>
      <StyledLogo
        display="inline-flex"
        gap="md"
        alignItems="center"
        data-testid="procore-logo"
      >
        {!isDesktop ? <ProcoreLogo /> : <MobileLogo />}
        <Typography
          weight="semibold"
          className={`font-size-${!isDesktop ? 'h1' : 'h2'}`}
        >
          {title}
        </Typography>
      </StyledLogo>
    </UnstyledLink>
  );
};

BrandingHeader.propTypes = {
  isDesktop: PT.bool.isRequired,
  marketplaceBasePath: PT.string.isRequired,
  title: PT.string.isRequired,
};

export default BrandingHeader;
